import MainContent from '../../components/mainContent/MainContent';
import { VisitasContratoContent } from './components/VisitasContratoContent';

export default function MisVisitasContrato() {
    return (
        <MainContent
            component={<VisitasContratoContent />}
            noBackground
            tableMaxWidth
        />
    );
};
